<template>
	<div>
		<div class="modal animated fadeIn" id="password-form1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-close-container">
				<button onclick="document.getElementById('password-form').style.display='none';" type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100">Resetirajte lozinku</h4>
					</div>
					<div class="modal-body mx-3 text-center">
						<form @submit="submit($event)" class="text-center mb-5">
							<div class="input-group mb-3">
								<input v-model="email" id="name" name="email" type="email" class="form-control" placeholder="E-adresa" aria-label="name" aria-describedby="basic-addon1" required>
							</div>
							<notify></notify>
							<button type="submit" class="fs-btn primary text-uppercase btn-lg">
								<loaderCircle v-if="loader"></loaderCircle>
								<span v-else>Resetirajte lozinku</span>
							</button>
							
						</form>
						<p class="modal-text"><a href="#" id="loginToggler" onclick="document.getElementById('password-form').style.display='none';" data-dismiss="modal" data-toggle="modal" data-target="#login-form">Povratak na prijavu</a></p>
					</div>
				</div>
			</div>
		</div>






		<div class="modal animated fadeIn" id="password-form2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" :class="verify_password== true ? 'show':'noshow'">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100 font-weight-bold mt-3">Resetirajte lozinku</h4>
						<button onclick="document.getElementById('password-form').style.display='none'; " @click="verify_password = false" type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mx-3" @submit="set($event)">
						<notify></notify>
						<form v-if="!failed">
							<div v-if="verified" class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text" id="basic-addon1"><i class="fa fa-envelope fa-1x"></i></span>
								</div>
								<input v-model="password" id="name" name="password" type="password" class="form-control" placeholder="Enter new password" aria-label="name" aria-describedby="basic-addon1" required>
							</div>
							<div v-if="verified" class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text" id="basic-addon1"><i class="fa fa-envelope fa-1x"></i></span>
								</div>
								<input v-model="confirm_password" id="name" name="password_confirmation" type="password" class="form-control" placeholder="Confirm new password" aria-label="name" aria-describedby="basic-addon2" required>
							</div>

							<button type="submit" class="fs-btn dark text-uppercase btn-lg btn-block">
								<span> Prijavi se </span>
							</button>
						</form>
					</div>
					<div class="modal-footer d-flex justify-content-center">
						<a href="#" style="color:black;font-weight:bold" onclick="document.getElementById('password-form').style.display='none';" data-dismiss="modal" data-toggle="modal" data-target="#login-form">Povratak na prijavu</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		name: 'forgot-password',
		data() {
			return {
				email: '',
				loading: false,
				password: '',
				confirm_password: '',
				verify_password: '',
				verified: false,
				failed: false,
				token: '',
				loader: false
			}
		},
		computed: {
			...mapState({
				endpoint: (state) => state.endpoint,
				notification: (state) => state.notification,
			}),
		},
		methods: {
			...mapMutations({
				setNotif: 'setNotification',
				setLoader: 'setLoader',
			}),
			set(e) {
				e.preventDefault();

				if (this.loader) {
					return false;
				}

				if (this.password.length == 0 || this.confirm_password.length == 0) {
					this.setNotif({
						type: 2,
						msg: 'All fields are required'
					});
					return false;
				}

				if (this.password.length != this.confirm_password.length) {
					this.setNotif({
						type: 2,
						msg: "Passwords doesn't match"
					});
					return false;
				}

				this.setLoader(true);
				this.$store.dispatch('post', {
						details: {
							password: this.password,
							password_confirmation: this.confirm_password,
							token: this.token
						},
						endpoint: this.endpoint + 'reset-password'
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.setNotif({
								type: 1,
								msg: data.data.msg
							});
							this.$router.push('/');
							document.getElementById("loginToggler").click();
							document.getElementById("password-form2").style.display = 'none';
						} else {
							this.setNotif({
								type: 2,
								msg: data.data.message
							});
						}
						this.setLoader(false);
					})
					.catch((error) => {
						console.log(error.request);
						if (error.request != null) {
							this.$store.dispatch("handleError", error);
						}
						this.setLoader(false);
					});
			},
			submit(e) {
				e.preventDefault();

				if (this.loader) {
					return false;
				}


				if (this.email.length == 0) {
					this.setNotif({
						type: 2,
						msg: "Please enter your email"
					});
					return false;
				}

				this.loader = true;
				this.$store.dispatch('post', {
						details: {
							email: this.email
						},
						endpoint: this.endpoint + 'forgot-password'
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.setNotif({
								type: 1,
								msg: data.data.msg
							});
						} else {
							this.setNotif({
								type: 2,
								msg: data.data.msg
							});
						}
						this.loader = false;
					})
					.catch((error) => {
						console.log(error.request);
						if (error.request != null) {
							this.$store.dispatch("handleError", error);
						}
						this.loader = false;
					});
			}
		},
		mounted() {

		},
		created() {

			if (this.$route.path.split('/').find(d => d == 'reset-password') != undefined) {
				this.setLoader(true);
				setTimeout(() => {
					window.$('#password-form2').modal('toggle');
				}, 500);

				this.$store.dispatch('post', {
						details: {
							token: this.$route.params.token
						},
						endpoint: this.endpoint + 'verify-token'
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.verified = true;
							this.token = this.$route.params.token;
							this.setNotif({
								type: 1,
								msg: data.data.msg
							});
						} else {
							this.verified = false;
							this.failed = true;
							this.setNotif({
								type: 2,
								msg: data.data.msg,
								unset: true
							});
						}
						this.setLoader(false);
					})
					.catch((error) => {
						console.log(error.request);
						if (error.request != null) {
							this.$store.dispatch("handleError", error);
						}
						this.failed = true;
						this.setLoader(false);
					});
			}
		}
	}

</script>
